import {
  ResponseRouteLegTypeEnum,
  RouteLegResponseType,
  TmdxAffiliateGroundLegResponse,
  TmdxDriveAffiliateGroundLegResponse,
  TmdxDriveTedsGroundLegResponse,
  TxCenterProviderGroundLegResponse,
} from '@/api/apis/route';
import { LogisticsGroundTrip } from '@/api/apis/drive-service';
import { getFullName } from '@/utils/helpers';

const GROUND_WITH_DRIVERS_LEG_TYPES = [
  ResponseRouteLegTypeEnum.TmdxAffiliateGroundLeg,
  ResponseRouteLegTypeEnum.TxCenterProviderGroundLeg,
];

const DRIVE_GROUND_TRIP_LEG_TYPES = [
  ResponseRouteLegTypeEnum.TmdxDriveAffiliateGroundLeg,
  ResponseRouteLegTypeEnum.TmdxDriveTedsGroundLeg,
];

export type DriverInfo = {
  driver: string;
  contact: string;
  type:
    | ResponseRouteLegTypeEnum.TmdxAffiliateGroundLeg
    | ResponseRouteLegTypeEnum.TxCenterProviderGroundLeg
    | ResponseRouteLegTypeEnum.TmdxDriveAffiliateGroundLeg
    | ResponseRouteLegTypeEnum.TmdxDriveTedsGroundLeg;
};

export const getNopConnectDrivers = (routesLegs?: RouteLegResponseType[]) => {
  if (!routesLegs) return [];

  const groundLegs = routesLegs.filter((l): l is TmdxAffiliateGroundLegResponse | TxCenterProviderGroundLegResponse =>
    GROUND_WITH_DRIVERS_LEG_TYPES.includes(l.$type as ResponseRouteLegTypeEnum),
  );

  const drivers = groundLegs.flatMap((r) => [
    ...(r.driver ? [{ driver: r.driver || '', contact: r.phoneNumber || '', type: r.$type }] : []),
  ]);

  return drivers;
};

export function getTmdxDriveDrivers(
  routeLegs: RouteLegResponseType[],
  driveTripsData: LogisticsGroundTrip[],
): DriverInfo[] {
  if (!routeLegs || !driveTripsData) return [];

  const groundTripLegs = routeLegs.filter(
    (l): l is TmdxDriveAffiliateGroundLegResponse | TmdxDriveTedsGroundLegResponse =>
      DRIVE_GROUND_TRIP_LEG_TYPES.includes(l.$type as ResponseRouteLegTypeEnum),
  );

  const drivers = groundTripLegs.reduce<DriverInfo[]>((acc, leg) => {
    const tripId = leg.tripReference?.tripId;
    if (!tripId) return acc;

    const trip = driveTripsData.find((t) => t.id === tripId);
    const driverData = trip?.driver?.driver;

    if (driverData) {
      acc.push({
        driver: getFullName(driverData.firstName, driverData.lastName),
        contact: driverData.phone || '',
        type: leg.$type,
      });
    }

    return acc;
  }, []);

  return drivers;
}
